import { digitsThree } from "./price";

export const formatWeight = (weight) => {
  if (!weight) return "";

  if (weight >= 1000) {
    const kg = weight / 1000;
    const value = Number.isInteger(kg) ? kg : parseFloat(kg.toFixed(2));
    return `${digitsThree(value)} کیلوگرم`;
  }

  return `${digitsThree(weight)} گرم`;
};
